// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.secondarycustom {
  background-color: transparent !important;
  border: 1px solid #FB263B !important;
  color: #FB263B !important;
  padding: 10px !important;
  font-size: 16px !important;
  font-family: "BarlowRegular" !important;
  font-weight: 600 !important;
  text-align: center !important;
  border-radius: 0px !important;
}

.primarycustom {
  background-color: #FB263B !important;
  border: 1px solid #FB263B !important;
  color: #fff !important;
  padding: 10px !important;
  font-size: 16px !important;
  font-family: "BarlowRegular" !important;
  font-weight: 600 !important;
  text-align: center !important;
  border-radius: 0px !important;
}

.primarycustom:not(:disabled):hover {
  background-color: #ED4E5C !important;
  border: 1px solid #ED4E5C !important;
}

.modal-backdrop.show {
  opacity: 0.2 !important;
}

.modal-augusta {
  display: flex !important;
  align-items: center;
}

.modal-content {
  border: none !important;
  border-radius: 0 !important;
  padding: 30px !important;
}

.modal-body {
  padding: 0 !important;
}

.modal-body .btn {
  padding: 0px !important;
}

.modal-header .btn {
  padding: 0 !important;
}

.modal-header {
  border-bottom: none !important;
  padding: 0 0 10px 0 !important;
  align-items: flex-start !important;
}

.modal-footer {
  border-top: none !important;
}

.modal-dialog {
  max-width: 634px !important;
  width: 100% !important;
}

.step-counter {
  font-family: "Inter";
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  color: var(--primary-color);
}

.radio-anim {
  background: #FFFFFF;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  width: 100%;
  padding: 20px;
  text-align: center;
  border-radius: 4px;
}

.radio-anim input {
  display: none;
}

.checked-radio {
  border: 1px solid var(--primary-color);
}

.ReactModal__Overlay {
  opacity: 0;
  transform: translateX(-100px);
  transition: all 500ms ease-in-out;
}

.ReactModal__Overlay--after-open {
  opacity: 1;
  transform: translateX(0px);
}

.ReactModal__Overlay--before-close {
  opacity: 0;
  transform: translateX(-100px);
}

.sub-title {
  font-family: "Inter";
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
  padding: 5px 0 10px 0;
}`, "",{"version":3,"sources":["webpack://./src/components/modals/modal.scss"],"names":[],"mappings":"AAAA;EACI,wCAAA;EACA,oCAAA;EACA,yBAAA;EACA,wBAAA;EACA,0BAAA;EACA,uCAAA;EACA,2BAAA;EACA,6BAAA;EACA,6BAAA;AACJ;;AACE;EACE,oCAAA;EACA,oCAAA;EACA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,uCAAA;EACA,2BAAA;EACA,6BAAA;EACA,6BAAA;AAEJ;;AACE;EACE,oCAAA;EACA,oCAAA;AAEJ;;AACA;EACI,uBAAA;AAEJ;;AAAA;EACI,wBAAA;EACA,mBAAA;AAGJ;;AADA;EACI,uBAAA;EACA,2BAAA;EACA,wBAAA;AAIJ;;AAFA;EACI,qBAAA;AAKJ;;AAHA;EACI,uBAAA;AAMJ;;AAJA;EACI,qBAAA;AAOJ;;AAJA;EACI,8BAAA;EACA,8BAAA;EACA,kCAAA;AAOJ;;AALA;EACI,2BAAA;AAQJ;;AANA;EACI,2BAAA;EACA,sBAAA;AASJ;;AAPA;EACI,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,2BAAA;AAUJ;;AARA;EACI,mBAAA;EACA,2CAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;AAWJ;;AARA;EACI,aAAA;AAWJ;;AATA;EACI,sCAAA;AAYJ;;AAVA;EACI,UAAA;EACA,6BAAA;EACA,iCAAA;AAaJ;;AAVE;EACE,UAAA;EACA,0BAAA;AAaJ;;AAVE;EACE,UAAA;EACA,6BAAA;AAaJ;;AAXE;EAEF,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;AAaA","sourcesContent":[".secondarycustom{\n    background-color: transparent!important;\n    border: 1px solid #FB263B!important;\n    color: #FB263B!important;\n    padding: 10px!important;\n    font-size: 16px!important;\n    font-family: \"BarlowRegular\"!important;\n    font-weight: 600!important;\n    text-align: center!important;\n    border-radius: 0px!important;\n  }\n  .primarycustom{\n    background-color: #FB263B!important;\n    border: 1px solid #FB263B!important;\n    color: #fff!important;\n    padding: 10px!important;\n    font-size: 16px!important;\n    font-family: \"BarlowRegular\"!important;\n    font-weight: 600!important;\n    text-align: center!important;\n    border-radius: 0px!important;\n  \n  }\n  .primarycustom:not(:disabled):hover {\n    background-color: #ED4E5C!important;\n    border: 1px solid #ED4E5C!important;\n}\n\n.modal-backdrop.show{\n    opacity: 0.2 !important;\n}\n.modal-augusta{\n    display: flex !important;\n    align-items: center;\n}\n.modal-content{\n    border: none !important;\n    border-radius: 0 !important;\n    padding: 30px !important;\n}\n.modal-body{\n    padding: 0 !important;\n}\n.modal-body .btn{\n    padding: 0px !important;\n}\n.modal-header .btn{\n    padding: 0 !important;\n}\n\n.modal-header{\n    border-bottom: none !important;\n    padding: 0 0 10px 0 !important;\n    align-items: flex-start !important;\n}\n.modal-footer{\n    border-top: none !important;\n}\n.modal-dialog{\n    max-width: 634px !important;\n    width: 100% !important;\n}\n.step-counter{\n    font-family: 'Inter';\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 16px;\n    letter-spacing: 0em;\n    text-align: left;\n    color:var(--primary-color);\n}\n.radio-anim{\n    background: #FFFFFF;\n    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);\n    width: 100%;\n    padding: 20px;\n    text-align: center;\n    border-radius: 4px;\n    \n}\n.radio-anim input{\n    display: none;\n}\n.checked-radio{\n    border: 1px solid var(--primary-color);\n}\n.ReactModal__Overlay {\n    opacity: 0;\n    transform: translateX(-100px);\n    transition: all 500ms ease-in-out;\n  }\n  \n  .ReactModal__Overlay--after-open {\n    opacity: 1;\n    transform: translateX(0px);\n  }\n  \n  .ReactModal__Overlay--before-close {\n    opacity: 0;\n    transform: translateX(-100px);\n  }\n  .sub-title{\n\nfont-family: 'Inter';\nfont-size: 16px;\nfont-weight: 600;\nline-height: 22px;\nletter-spacing: 0em;\ntext-align: left;\npadding: 5px 0 10px 0;\n\n\n\n  }\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
